/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./priority-dialog.vue?vue&type=template&id=499a61b9&scoped=true&"
import script from "./priority-dialog.vue?vue&type=script&lang=ts&"
export * from "./priority-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./priority-dialog.vue?vue&type=style&index=0&id=499a61b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499a61b9",
  null
  
)

export default component.exports